import React, { useEffect, useState } from 'react'
import { DefaultDiplomInterface, DiplomInterface, ShowDiplomsContext } from './types'
import SuccessMsg from '../../Messages/SuccessMsg'
import { FaPlus } from 'react-icons/fa'
import AddDiplomModal from './AddDiplomModal'
import { useParams } from 'react-router'
import { useDispatch } from 'react-redux'
import { getDiplomsApi } from '../../redux/diploms/diplomApiCalls'
import DataDiploms from './DataDiploms'
import EditDiplomModal from './EditDiplomModal'
import DeleteDiplomModal from './DeleteDiplomModal'

const ShowDiploms = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showAddDiplom, setShowAddDiplom] = useState(false)
  const [showEditDiplom, setShowEditDiplom] = useState(false)
  const [showDeleteDiplom, setShowDeleteDiplom] = useState(false)
  const [selectedDiplom, setSelectedDiplom] = useState<DiplomInterface>(DefaultDiplomInterface)

  const { doctorId } = useParams()
  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchApis = async () => {
      await dispatch(getDiplomsApi(doctorId))
    }
    fetchApis()
  }, [dispatch, doctorId])

  return (
    <ShowDiplomsContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showAddDiplom, setShowAddDiplom,
      showEditDiplom, setShowEditDiplom,
      showDeleteDiplom, setShowDeleteDiplom,
      selectedDiplom, setSelectedDiplom,
    }}>
      <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/>
      <div className="flex justify-start gap-2">
        <button className="p-2 rounded btn-main" onClick={() => setShowAddDiplom(!showAddDiplom)}>
          <FaPlus />
        </button>
      </div>
      <AddDiplomModal modal={showAddDiplom} toggle={() => setShowAddDiplom(!showAddDiplom)} />
      {showEditDiplom && <EditDiplomModal modal={showEditDiplom} toggle={() => setShowEditDiplom(!showEditDiplom)} />}
      {showDeleteDiplom && <DeleteDiplomModal modal={showDeleteDiplom} toggle={() => setShowDeleteDiplom(!showDeleteDiplom)} />}
      
      <DataDiploms />

    </ShowDiplomsContext.Provider>
  )
}

export default ShowDiploms